export default __webpack_public_path__ + "static/media/36I-114286_-20676_0.1db1fd16.jpg";